import { EstimateWithComponentsDto } from "../dtos/estimate-with-components.dto";

// The server's totalCost is the full job total: labor, equipment (billed at
// each equipment's rate, minimum-billing aware), and additional cost items.
// Equipment assignments and rates aren't part of this DTO, so recomputing from
// trees undercounts — only fall back to the labor sum for legacy snapshots
// that predate totalCost.
export const estimateTotalCost = (estimate: EstimateWithComponentsDto) => {
  return estimate.totalCost ?? estimate.trees.reduce((acc, tree) =>
    acc + tree.operations.reduce((acc, operation) =>
      acc + (operation.estimatedCost ?? 0), 0), 0);
}
